import React, { useEffect } from 'react'
import { useLocation } from "react-router-dom"

const MissingRoute = () => {
    let {pathname, search} = useLocation();
   
    useEffect(() => {
        window.location.href = `https://${process.env.REACT_APP_REDIRECT_URL}` + pathname + search
    },[])
    return (
        <div className="container">
            Redirecting...
        </div>
    )
}

export default MissingRoute
